// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mentions-legales-page {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  width: 100%;
  padding: 2rem;
  margin: 0 !important;
}

.mentions-legales-title-h1 {
  color: #f97316;
}

.mentions-legales-title-h2 {
  color: #f97316;
  margin-top: 1.5rem;
}

.mentions-legales-title-h3 {
  color: #f97316;
  margin-top: 1.5rem;
}

.mentions-legales-title-h4 {
  color: #f97316;
  margin-top: 1.5rem;
}

.mentions-legales-custom-container {
  max-width: inherit !important;
  margin: 0 !important;
}

.mentions-legales-custom-paragraph {
  margin-bottom: 1em;
}

.mentions-legales-custom-ul {
  list-style-type: disc;
  margin-left: 20px;
  margin-bottom: 1em;
}

.mentions-legales-custom-title-h1 {
  color: #f97316;
}

.mentions-legales-custom-title-h2 {
  color: #f97316;
}

.mentions-legales-custom-title-h3 {
  color: #f97316;
}

.mentions-legales-custom-title-h4 {
  color: #f97316;
  margin-top: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/pages/MentionsLegales/MentionsLegales.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".mentions-legales-page {\n  font-family: Arial, sans-serif;\n  line-height: 1.6;\n  width: 100%;\n  padding: 2rem;\n  margin: 0 !important;\n}\n\n.mentions-legales-title-h1 {\n  color: #f97316;\n}\n\n.mentions-legales-title-h2 {\n  color: #f97316;\n  margin-top: 1.5rem;\n}\n\n.mentions-legales-title-h3 {\n  color: #f97316;\n  margin-top: 1.5rem;\n}\n\n.mentions-legales-title-h4 {\n  color: #f97316;\n  margin-top: 1.5rem;\n}\n\n.mentions-legales-custom-container {\n  max-width: inherit !important;\n  margin: 0 !important;\n}\n\n.mentions-legales-custom-paragraph {\n  margin-bottom: 1em;\n}\n\n.mentions-legales-custom-ul {\n  list-style-type: disc;\n  margin-left: 20px;\n  margin-bottom: 1em;\n}\n\n.mentions-legales-custom-title-h1 {\n  color: #f97316;\n}\n\n.mentions-legales-custom-title-h2 {\n  color: #f97316;\n}\n\n.mentions-legales-custom-title-h3 {\n  color: #f97316;\n}\n\n.mentions-legales-custom-title-h4 {\n  color: #f97316;\n  margin-top: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
